<template>
  <div class="intelligent">
    <!-- 智能车载核心板-->
    <div v-if="language==1">
      <div class="indexa_box">
        <img src="../../../static/bg/intelligenttopbg.png" alt="">
        <div class="wrap">
          <div class="swiper_box">
            <el-carousel :interval="4000" type="card" height="360px" width="400px">
              <el-carousel-item v-for="item in imgArr" :key="item">
                <img :src="item" alt="" style="width:100%;height:100%;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <img src="../../../static/bg/intelligentbottombg.png" alt="">
      </div>
    </div>
    <div v-if="language==0">
      <div class="indexa_box">
        <img src="../../../static/bg/intelligenttopbgEng.png" alt="">
        <div class="wrap">
          <div class="swiper_box">
            <el-carousel :interval="4000" type="card" height="360px" width="400px">
              <el-carousel-item v-for="item in imgArrEng" :key="item">
                <img :src="item" alt="" style="width:100%;height:100%;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <img src="../../../static/bg/intelligentbottombgEng.png" alt="">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "polarisTripREC",
  data() {
    return {
      imgArr: [
        "../../../static/activeSafety/intelligent/intelligent1.png",
        "../../../static/activeSafety/intelligent/intelligent2.png",
        "../../../static/activeSafety/intelligent/intelligent3.png"
      ],
      imgArrEng: [
        "../../../static/activeSafety/intelligent/intelligentEng1.png",
        "../../../static/activeSafety/intelligent/intelligentEng2.png",
        "../../../static/activeSafety/intelligent/intelligentEng3.png"
      ]
    };
  },
  mounted() {},
  computed: {
    language() {
      // 1中文，0英文
      return this.$store.state.langurage;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.intelligent /deep/ {
  .el-carousel__arrow {
    background-color: #000;
    opacity: 0.5;
    color: #fff;
  }
  .el-carousel__arrow:hover {
    background-color: #000;
    opacity: 0.7;
    color: #fff;
  }
 
}
 .indexa_box {
    margin: 0 auto;
  }
  .wrap {
    height: 560px;
  }
  .swiper_box {
    width: 800px;
    padding-top: 60px;
    margin: 0 auto;
  }
  img {
    width: 100%;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Product/intelligent.vue